export default __webpack_public_path__ + "bc027e61145c7db43842c3338587ae1c.svg";